const THEME = {
  COLORS: {
    PRIMARY_PURPLE: 'var(--primary-purple)',
    PRIMARY_PURPLE_DARK: 'var(--primary-purple-dark)',
    PRIMARY_PURPLE_LIGHT: 'var(--primary-purple-light)',

    NEUTRAL_BLACK: 'var(--neutral-black)',
    NEUTRAL_WHITE: 'var(--neutral-white)',
    NEUTRAL_BLACK_LIGHT: 'var(--neutral-black-light)',
    NEUTRAL_BLACK_LIGHTER: 'var(--neutral-black-lighter)',
    NEUTRAL_WHITE_LIGHT: 'var(--neutral-white-light)',
    NEUTRAL_WHITE_LIGHTER: 'var(--neutral-white-lighter)',
    NEUTRAL_GRAY: 'var(--neutral-gray)',
    NEUTRAL_GRAY_LIGHT: 'var(--neutral-gray-light)',
    NEUTRAL_GRAY_DARK: 'var(--neutral-gray-dark)',
    NEUTRAL_LIGHT_GRAY: 'var(--neutral-light-gray)'
  },

  TYPOGRAPHY: {
    FONT_FAMILY: {
      PRIMARY: 'NeueHaasGrotesk, Arial, sans-serif',
      SECONDARY: 'NeueHaasGrotesk, Arial, sans-serif'
    },
    FONT_SIZE: {
      XS: '0.75rem',
      SMALL: '0.875rem',
      MEDIUM: '1rem',
      LARGE: '1.25rem',
      XL: '1.5rem',
      XXL: '2rem',
      XXXL: '2.5rem'
    },
    FONT_WEIGHT: {
      LIGHT: 300,
      REGULAR: 400,
      MEDIUM: 500,
      SEMI_BOLD: 600,
      BOLD: 700,
      EXTRA_BOLD: 800
    },
    LINE_HEIGHT: {
      TIGHT: 1.2,
      NORMAL: 1.5,
      RELAXED: 1.75
    }
  },

  SPACING: {
    XS: '0.25rem',
    SMALL: '0.5rem',
    MEDIUM: '1rem',
    LARGE: '1.5rem',
    XL: '2rem',
    XXL: '3rem',
    XXXL: '4rem'
  },

  BORDERS: {
    RADIUS: {
      SMALL: '2px',
      MEDIUM: '4px',
      LARGE: '8px',
      EXTRA_LARGE: '12px',
      ROUND: '50%'
    },
    WIDTH: {
      THIN: '1px',
      MEDIUM: '2px',
      THICK: '4px'
    }
  },

  SHADOWS: {
    SMALL: '0 2px 5px rgba(0, 0, 0, 0.1)',
    MEDIUM: '0 4px 10px rgba(0, 0, 0, 0.1)',
    LARGE: '0 8px 16px rgba(0, 0, 0, 0.1)',
    EXTRA_LARGE: '0 12px 24px rgba(0, 0, 0, 0.15)'
  },

  TRANSITIONS: {
    FAST: '0.2s',
    MEDIUM: '0.3s',
    SLOW: '0.5s'
  },

  BREAKPOINTS: {
    XS: 0,
    SM: 600,
    MD: 960,
    LG: 1280,
    XL: 1920
  },

  Z_INDEX: {
    LOWEST: 0,
    LOW: 10,
    MEDIUM: 100,
    HIGH: 1000,
    HIGHEST: 9999
  }
};

THEME.up = breakpoint =>
  `@media (min-width: ${THEME.BREAKPOINTS[breakpoint]}px)`;
THEME.down = breakpoint =>
  `@media (max-width: ${THEME.BREAKPOINTS[breakpoint] - 0.05}px)`;
THEME.between = (start, end) =>
  `@media (min-width: ${THEME.BREAKPOINTS[start]}px) and (max-width: ${THEME.BREAKPOINTS[end] - 0.05}px)`;

export default THEME;
